import { render, staticRenderFns } from "./UiWarning.vue?vue&type=template&id=06e6fa7c"
import script from "./UiWarning.vue?vue&type=script&lang=js"
export * from "./UiWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports